import { useAuth } from "@/lib/auth";

/** Mirrors require_permission("leads_manage") — superadmins always pass. */
export function useCanManageLeads() {
  const { user } = useAuth();
  return user?.role === "superadmin"
    || (user?.role === "admin" && !!user?.permissions?.leads_manage);
}
